export const TRAINING_STEP_TYPE = { ENTRAINEMENT: 1, OBLIGATOIRE: 2, EVALUATION: 3 };
export const CSS_CLASS_CIRCLE_OPTIONAL = "circle-optional";
export const CSS_CLASS_CIRCLE_MANDATORY = "circle-mandatory";